import { render, staticRenderFns } from "./settlementDetail.vue?vue&type=template&id=a686e016&scoped=true&"
import script from "./settlementDetail.vue?vue&type=script&lang=js&"
export * from "./settlementDetail.vue?vue&type=script&lang=js&"
import style0 from "./settlementDetail.vue?vue&type=style&index=0&id=a686e016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a686e016",
  null
  
)

export default component.exports